// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.planSelector{
    display: flex;
    margin-bottom: 20px;
}
.MuiGrid-root.currencySelector{
   display: block;
   @media screen and (min-width: 1025px){
    display: flex;
    justify-content: end;
    height: 100px;
    align-items: center;
    width: 100%;
    gap: 40px;
    
   }
}
.MuiTypography-root.payment-text{
    font-size: 10px;
    font-weight: 400;
   font-style: italic;
   font-family: var(--font-family-primary);
   letter-spacing: 0.3px;
   line-height: 14px;
}
.MuiTypography-root.currency-text{
    font-size: 13px;
    font-family: var(--font-family-primary);
    font-weight: 600;
    line-height: 17px;
    letter-spacing: 0.3px;
    text-align: left;
}

/* radio-button checked style */
.MuiButtonBase-root.Mui-checked{
    color: #C59FE8 !important;
}
.flag-icon{
    width: 20px;
    height: 14px;
    border-radius: 2px;
}
.MuiBox-root.flag-container{
    display: flex;
    align-items: center;
    gap: 8px
}
.MuiBox-root.pricing-container{
    height: 100%;
    overflow-y: auto;
    padding: 32px;
    text-align: left;
}
.MuiTypography-root.price-text{
    display: inline-block;
  background: #E21515;
  color: white;
  padding: 4px 3px;
  font-size: 16px;
  font-weight: 600;
  font-family: var(--font-family-primary);
  position: relative;
  color: #EBEBF5;
  border-top-left-radius: 10px;

}
.MuiTypography-root.price-text::after{
    content: "";
    position: absolute;
    top: 0;
    right: -14px;
    width: 0;
    height: 0;
    border-top: 13px solid #E21515;
    border-bottom: 15px solid #E21515;
    border-left: 15px solid transparent;
    transform: rotate(180deg);
}
.MuiBox-root.ribbon-price-container{
    position: absolute;
    top: 0;
    left: 0px;
    
}`, "",{"version":3,"sources":["webpack://./src/components/Subscription/Subscription.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;GACG,cAAc;GACd;IACC,aAAa;IACb,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,SAAS;;GAEV;AACH;AACA;IACI,eAAe;IACf,gBAAgB;GACjB,kBAAkB;GAClB,uCAAuC;GACvC,qBAAqB;GACrB,iBAAiB;AACpB;AACA;IACI,eAAe;IACf,uCAAuC;IACvC,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA,+BAA+B;AAC/B;IACI,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB;AACJ;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,qBAAqB;EACvB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uCAAuC;EACvC,kBAAkB;EAClB,cAAc;EACd,4BAA4B;;AAE9B;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,iCAAiC;IACjC,mCAAmC;IACnC,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;;AAEb","sourcesContent":[".planSelector{\n    display: flex;\n    margin-bottom: 20px;\n}\n.MuiGrid-root.currencySelector{\n   display: block;\n   @media screen and (min-width: 1025px){\n    display: flex;\n    justify-content: end;\n    height: 100px;\n    align-items: center;\n    width: 100%;\n    gap: 40px;\n    \n   }\n}\n.MuiTypography-root.payment-text{\n    font-size: 10px;\n    font-weight: 400;\n   font-style: italic;\n   font-family: var(--font-family-primary);\n   letter-spacing: 0.3px;\n   line-height: 14px;\n}\n.MuiTypography-root.currency-text{\n    font-size: 13px;\n    font-family: var(--font-family-primary);\n    font-weight: 600;\n    line-height: 17px;\n    letter-spacing: 0.3px;\n    text-align: left;\n}\n\n/* radio-button checked style */\n.MuiButtonBase-root.Mui-checked{\n    color: #C59FE8 !important;\n}\n.flag-icon{\n    width: 20px;\n    height: 14px;\n    border-radius: 2px;\n}\n.MuiBox-root.flag-container{\n    display: flex;\n    align-items: center;\n    gap: 8px\n}\n.MuiBox-root.pricing-container{\n    height: 100%;\n    overflow-y: auto;\n    padding: 32px;\n    text-align: left;\n}\n.MuiTypography-root.price-text{\n    display: inline-block;\n  background: #E21515;\n  color: white;\n  padding: 4px 3px;\n  font-size: 16px;\n  font-weight: 600;\n  font-family: var(--font-family-primary);\n  position: relative;\n  color: #EBEBF5;\n  border-top-left-radius: 10px;\n\n}\n.MuiTypography-root.price-text::after{\n    content: \"\";\n    position: absolute;\n    top: 0;\n    right: -14px;\n    width: 0;\n    height: 0;\n    border-top: 13px solid #E21515;\n    border-bottom: 15px solid #E21515;\n    border-left: 15px solid transparent;\n    transform: rotate(180deg);\n}\n.MuiBox-root.ribbon-price-container{\n    position: absolute;\n    top: 0;\n    left: 0px;\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
